<script setup>

/**
 * Page de la liste des factures de l'utilisateur
 */

import { ref, computed, defineAsyncComponent, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
/***/
import { useApplicationStore } from '@stores/application';
/***/
import { useAuthUser } from '@compositions/Auth';

// Composants
const Layout = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/Layouts/Authenticated'));
const BillList = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/Partial/Me/Account/Bill/List'));

const router = useRouter();
const { t } = useI18n();

// Stores
const applicationStore = useApplicationStore();

const currentApplication = computed(() => applicationStore.getCurrent);

// Composition pour l'utilisateur connecté
const { authUserHasPermission } = useAuthUser({});

const allowed = ref(false);

// Retourne le titre de la page
const pageTitle = computed(() => t('page.me.account.bills.list.title'));

onMounted(() => {
    if(! (authUserHasPermission('to have bills') && authUserHasPermission('consult bills'))) {
        router.push({
            name: 'error',
            params: {
                statusCode: 404
            }
        });
    } else {
        allowed.value = true;
        document.title = pageTitle.value + ' - ' + currentApplication.value.name;
    }
});
</script>

<template>
    <layout v-if="allowed">
        <div class="content_header">
            <div class="content-header_title">
                <h1 class="first-title">{{ pageTitle }}</h1>
            </div>
        </div>

        <bill-list></bill-list>
    </layout>
</template>
